import classNames from 'classnames';
import { useHistory, useLocation, useParams } from 'react-router';
import { useTypedSelector } from '../../../../../../store/reducers/use-typed-selector';
import { CallToAction, CallToActionType, LanguagesAbbr, PageLinkType, PageModule, PageModuleType } from '../../../../../../types/working-model';
import { parseUrl } from '../../../../../../utils/utils';
import { eventPath } from '../../../../../live-event/utils';

interface INavItemProps {
	navItem: CallToAction;
	handleScroll: (p: PageModuleType) => void;
	className?: string;
	isEditor?: boolean;
	previewLanguage?: LanguagesAbbr
}

export default function NavItem({ navItem, handleScroll, className = 'navigation-link', isEditor = false, previewLanguage }: INavItemProps): JSX.Element {
	const {
		workingEvent
	} = useTypedSelector(state => ({
		workingEvent: state.CreateEventReducer.workingEvent
	}));
	// const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const history = useHistory();
	const { pathname } = useLocation();
	let link;
	const { language: pathLanguage, eventName, uuid } = useParams() as any;

	const language = previewLanguage ? previewLanguage : pathLanguage; //when in preview modal portal we no longer have access to params
	function handlePageNav() {
		if (isEditor) {
			if (navItem.content.page === PageLinkType.landing) {
				history.push(`/admin/events/create/${workingEvent?.uuid}/homepage`);
			} else if (navItem.content.page === PageLinkType.termsAndConditions) {
				history.push(`/admin/events/create/${workingEvent?.uuid}/event/terms-conditions`);
			} else if (navItem.content.page === PageLinkType.privacyPolicy) {
				history.push(`/admin/events/create/${workingEvent?.uuid}/event/privacy-policy`);
			} else (
				history.push(navItem?.content?.page ?? '')
			);
		} else {
			if (navItem.content.page === PageLinkType.landing) {
				history.push(`/${eventPath(eventName, uuid)}/${language}`);
			} else if (navItem.content.page === PageLinkType.termsAndConditions) {
				history.push(`/${eventPath(eventName, uuid)}/${language}/terms-conditions`);
			} else if (navItem.content.page === PageLinkType.privacyPolicy) {
				history.push(`/${eventPath(eventName, uuid)}/${language}/privacy-policy`);
			} else {
				history.push(navItem?.content?.page ?? '');
			}
		}
	}
	function getTextValue() {
		const useBase = (navItem?.button_name?.changed === 'true' || pathname.includes('/theme/landing'));
		return navItem?.button_name[useBase ? 'base' : language];
	}

	switch (navItem.type) {
		case CallToActionType.page:
			link = <span className={className} onClick={handlePageNav}>{getTextValue()}</span>;
			break;
		case CallToActionType.section:
			link = (
				<a className={classNames(className, 'no-style')} onClick={() => handleScroll(navItem.content?.section || 0)}>
					{getTextValue()}
				</a>
			);
			break;
		case CallToActionType.url:
			link = navItem.content.url ?
				<a
					className={className}
					href={parseUrl(navItem.content.url!)}
					target="_blank" rel="noreferrer"
				>
					{getTextValue()}
				</a>
				: getTextValue();
			break;
		default:
			link = "Link type not found";
	}

	return (
		<>
			{link}
		</>
	);
}

export function checkLinkedSectionIsOn(navItem: CallToAction, activePageModules: PageModuleType[]): boolean {
	if (navItem.type === CallToActionType.section && navItem.content.section) {
		return activePageModules.includes(navItem.content.section);
	}
	return true;
}

export function filterActiveModules(modules?: PageModule[]): PageModuleType[] {
	return modules?.filter(m => m.is_on).map(m => m.type) || [];
}
